var BlimpExtListingUtilities = new Class({
	Extends: BlimpExt,
	options: {
		pg_width_by_thumbs: 5,
		data: null
	},

	post_process_build: function(){
		this.parent();
		if(!this.first_load){
			this.set_default_view();
		}
		else{
			if(this._link.hasClass('gallery_link')){
				this.status_view = 'pg';
			}
			else if(this._link.hasClass('floorplan_link')){
				this.status_view = 'fp';
			}
			else{
				this.status_view = 'mp';
			}

			if(this.status_view == 'mp'){
		 		this._monitor = this._element.getElement('.map_container');
		 		this.initialize_map();
		 	}
		 	else{
		 		this._monitor = this._element.getElement('.photogallery_container');
		 		this.create_gallery();
		 	}

			this.add_links();
		}

		this.first_load = false;
	},

	add_links: function(){
		var _link_container = this._element.getElement('.link_container');

		if(!_link_container || !_link_container.hasClass('_for_listing')) return;

		this._contact_btn =  _link_container.getElement('.contact_btn a');

		if(!this._link.getParent('.lst') || !this._link.getParent('.lst').getElement('.map_view') && !this._contact_btn && (this.data.photos.length == 0 || this.data.floorplan.length == 0)){
			_link_container.dispose();
		}
		else{
			if(this._link.getParent('.lst').getElement('.map_view')){
				this._mp_link = new Element('a',{
					'href': '#',
					'text': 'View Map',
					'class': 'map_view raquo ' + (this.status_view == 'mp' ? '_active' : ''),
					'data-rpc' : this._link.getParent('.lst').getElement('.map_view').getAttribute('data-rpc-map')
				}).inject(_link_container, 'top');
			}

			if(this._link.getParent('.lst').getElement('.floorplan_link') || (this.data.floorplan && this.data.floorplan.length > 0)){
				this._fp_link = new Element('a',{
					'href': '#',
					'text': 'View Floorplan',
					'class': 'floorplan raquo ' + (this.status_view == 'fp'? '_active' : ''),
					'data-rpc' : this._link.getParent('.lst').getElement('.floorplan_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}

			if(this._link.getParent('.lst').getElement('.gallery_link') || (this.data.photos && this.data.photos.length > 0)){
				this._pg_link = new Element('a',{
					'href': '#',
					'text': 'View Photo Gallery',
					'class': 'photogallery raquo ' + (this.status_view == 'pg' ? '_active' : ''),
					'data-rpc' : this._link.getParent('.lst').getElement('.gallery_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}
		}

		// to have some space so the contact btn wont overlapped with the gallery widget if theres no listed by and managed by
		if(this._pg_link
			&& this._fp_link
			&& this._mp_link
			&& _link_container.getElement('.contact_btn')
			&& !this._element.getElement('.listed_by')
			&& !this._element.getElement('.managed_by')){

			var _header = this._element.getElement('h3');

			if(_header) _header.setStyle('padding-bottom', 30);
		}

		this.add_links_functionality();
	},

	add_links_functionality: function(){
		var _fp, _pg, _mp;

		if(this._fp_link){
			this._fp_link.addEvent('click', function(e){
				if(e && e.stop) e.stop();

				if(this.status_view == 'pg'){
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if(_pg) _pg.dispose();

				if(this.status_view == 'mp'){
					_mp = this._monitor.getElement('.map');
				}

				if(_mp) _mp.dispose();

				if(!_fp){
					var data = null;

					if(this.data.floorplan){
						data = {
							photos: this.data.floorplan,
							content: this.data.content
						};
					}

					this.initialize_gallery(this._monitor, data)
					_fp = this._monitor.getElement('.w_photogallery');
				}else{
					this._monitor.adopt(_fp);
				}

				if(this._pg_link) this._pg_link.removeClass('_active');

				if(this._mp_link) this._mp_link.removeClass('_active');

				this._fp_link.addClass('_active');
				this.status_view = 'fp';
			}.bind(this));
		}

		if(this._pg_link){
			this._pg_link.addEvent('click', function(e){
				if(e && e.stop) e.stop();

				if(this.status_view == 'fp'){
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if(_fp) _fp.dispose();

				if(this.status_view == 'mp'){
					_mp = this._monitor.getElement('.map');
				}

				if(_mp) _mp.dispose();

				if(!_pg){
					var data = (this.data.photos) ? this.data : null;

					this.initialize_gallery(this._monitor, data)
					_pg = this._monitor.getElement('.w_photogallery');
				}else{
					this._monitor.adopt(_pg);
				}

				if(this._fp_link) this._fp_link.removeClass('_active');

				if(this._mp_link) this._mp_link.removeClass('_active');

				this._pg_link.addClass('_active');
				this.status_view = 'pg';
			}.bind(this));
		}

		if(this._mp_link){
			this._mp_link.addEvent('click', function(e){
				if(e && e.stop) e.stop();

				if(this.status_view == 'pg'){
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if(_pg) _pg.dispose();

				if(this.status_view == 'fp'){
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if(_fp) _fp.dispose();

				if(!_mp){
					this.initialize_map();
					_mp = this._monitor.getElement('.map');
				}
				else{
					this._monitor.adopt(_mp);
				}

			 	if(this._pg_link) this._pg_link.removeClass('_active');

				if(this._fp_link) this._fp_link.removeClass('_active');

			 	this._mp_link.addClass('_active');
			 	this.status_view = 'mp';

			}.bind(this));
		}

		if(this._contact_btn && this._link.getParent('.ava_apts')){
			new Blimp.Form(this._contact_btn, {draggable: true, allow_others: true});
		}
	},

	set_default_view: function(){
		if(this._element.getElement('.w_popup').hasClass('floorplan') && this.status_view != 'fp'){
			if(this._fp_link) this._fp_link.fireEvent('click');
		}
		else if(this._element.getElement('.w_popup').hasClass('photogallery') && this.status_view != 'pg'){
			if(this._pg_link) this._pg_link.fireEvent('click');
		}
		else if(this.status_view != 'mp'){
			if(this._mp_link) this._mp_link.fireEvent('click');
		}
	},

	create_gallery: function() {
		if(!this.photogallery) {
			var fp_data;
			this.data = this.data || this.options.data;

			if(this._element.getElement('.w_popup').hasClass('floorplan') && this.data.floorplan){
				fp_data = {
					photos: (this.data.floorplan && this.data.floorplan.length > 0)? this.data.floorplan : this.data.photos,
					content: this.data.content
				};
			}

			var _phg = this._element.getElement('.w_photogallery');

			var data = fp_data || this.data;

			this.initialize_gallery(_phg, data);

			//this.photogallery.popup = this;
		}
	},

	initialize_gallery: function(_element, data){
		var self = this;

		if(data){
			new PagePhotogallery(_element, {
				data: data,
				thumbs_amount: this.options.width_by_thumbs,
				no_fullscreen_opt: true
			});
		}
		else{
			var rpc;

			if(this.status_view == 'fp'){
				rpc = this._fp_link.getAttribute('data-rpc');
			}
			else{
				rpc = this._pg_link.getAttribute('data-rpc');
			}

			self.remote = new Remote({
				rpc: rpc,
				method: 'get',
				onSuccess: function(){
					var data = this.get_data();

					self.data.content = data.content;
					self.data.photos = data.photos;
					self.data.floorplan = data.floorplan;

					if(self.status_view == 'fp'){
						data = {
							photos: data.floorplan,
							content: data.content
						};
					}

					new PagePhotogallery(_element, {
						data: data,
						thumbs_amount: self.options.width_by_thumbs,
						no_fullscreen_opt: true
					});
				}
			});
		}
	},

	initialize_map: function(){
		var self = this;
		var rpc	= (this._mp_link) ? this._mp_link.getAttribute('data-rpc') : this._link.getAttribute('data-rpc-map');
		var _map = new Element('div', {
						'class': 'map'
					}).inject(this._monitor);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function(){
				var data = this.get_data();

				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	}
});
